export default __webpack_public_path__ + "static/media/girlsitting.62b1f5a7.svg";